export default __webpack_public_path__ + "static/Ogg-Roman-0d75c7443c51ce237ed606c5e1cc69b2.woff";